import { EQpProfile } from '@library/models/qp-profile.models';
import { BrdRoutes } from '@one/app/pages/brd/brd-routes';
import { resolveBiotechLandingPath } from '@one/app/pages/brd/pages/biotech/biotech-landing';
import {
  isHarvestClientEntityType,
  resolveHarvestClientEntityLandingPath,
} from '@one/app/pages/brd/pages/biotech/harvest-client-entity-roles';
import { AccountService } from '@one/app/shared/services/account/account.service';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'one-home',
  template: '',
  standalone: true,
})
export class HomeComponent {
  public readonly _accountService = inject(AccountService);
  public readonly _router = inject(Router);

  public constructor() {
    void this.checkAuthority();
  }

  public async checkAuthority(): Promise<void> {
    const brandId = this._accountService.getBrandId();
    const inspectorsProfiles = [EQpProfile.ROLE_INSPECTOR, EQpProfile.ROLE_SERVICE_PROVIDER_INSPECTOR];

    if (this._accountService.hasAnyAuthority(inspectorsProfiles)) {
      this._navigateTo('/isp');
    } else if ((await this._accountService.hasAuthority(EQpProfile.ROLE_SUPERVISOR)) && brandId) {
      await this._navigateBrandUser();
    } else if (await this._accountService.hasAuthority(EQpProfile.ROLE_SUPERVISOR)) {
      this._navigateTo('/select-brand');
    } else if (this._accountService.hasAnyAuthority([EQpProfile.ROLE_BRAND, EQpProfile.ROLE_ENTITY])) {
      if (this._accountService.hasAnyAuthority([EQpProfile.ROLE_BRAND])) {
        await this._navigateBrandUser();
      } else {
        await this._navigateEntityUser();
      }
    } else if (this._accountService.hasAnyAuthority([EQpProfile.ROLE_SERVICE_PROVIDER])) {
      this._navigateTo('/sp');
    } else {
      this._navigateTo('/404');
    }
  }

  private async _navigateBrandUser(): Promise<void> {
    const brand = await firstValueFrom(this._accountService.getBrand$());

    if (brand?.biotechEnabled) {
      const account = await this._accountService.identity();
      const landingPath = resolveBiotechLandingPath(account?.permissions ?? [], account?.role, account?.entityTypeId);

      this._navigateTo(landingPath ?? BrdRoutes.biotechHome());

      return;
    }

    this._navigateTo('/brd');
  }

  private async _navigateEntityUser(): Promise<void> {
    const account = await this._accountService.identity();

    if (isHarvestClientEntityType(account?.entityTypeId)) {
      this._navigateTo(resolveHarvestClientEntityLandingPath());

      return;
    }

    this._navigateTo('/brd');
  }

  private _navigateTo(path: string): void {
    void this._router.navigate([path]);
  }
}
